@if (userProfile) {
    @if (dynamicPanel) {
        <fm-rp-user-profile [userProfile]="userProfile" />
    } @else {
        <fm-user-profile [userProfile]="userProfile" />
    }
}
